import { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash"
import TextareaAutosize from 'react-textarea-autosize';

export const FormTextInput = ({
  id,
  name,
  value,
  disabled,
  onChange,
  onContextMenu,
  onKeyDown,
  placeholder = null,
  error,
  touched,
  title,
  style,
  isLoading,
  minlength,
  maxlength,
}) => {
  const spanRef = useRef();
  const inputRef = useRef();
  const textareaRef = useRef();
  const [useInputText, setUseInputText] = useState(true);
  const [internalStyle, setInternalStyle] = useState(_.cloneDeep(style));
  const [internalTextAreaStyle, setInternalTextAreaStyle] = useState(_.cloneDeep(style));
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(0);
  const [focused, setFocused] = useState(false);
  const spanStyle = _.cloneDeep(style);
  delete spanStyle.width;
  delete spanStyle.maxWidth;
  spanStyle.zIndex = -100;
  const minmaxProps = {};
  if (minlength) {  
    minmaxProps.minlength = minlength;
  }
  if (maxlength) {
    minmaxProps.maxlength = maxlength;
  }

  useEffect(() => {
    const width = spanRef.current.offsetWidth + 18;
    setInternalStyle((prevState) => ({
      ...prevState,
      width: width,
      maxWidth: spanRef.current.parentElement?.offsetWidth,
    }));
    setInternalTextAreaStyle((prevState) => ({
      ...prevState,
      width: width,
      maxWidth: spanRef.current.parentElement?.offsetWidth,
      lineHeight: 'inherit',
    }));
    setUseInputText(width <= spanRef.current?.parentElement?.offsetWidth ? true : false);
  }, [value])

  useEffect(() => {
    if (focused) {
      if (useInputText) {
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.setSelectionRange(start, end);
        }
      } else {
        if (textareaRef.current) {
          textareaRef.current.focus();
          textareaRef.current.setSelectionRange(start, end);
        }
      }
    }
  }, [useInputText])

  const classNames = () => {
    let result = "tw-w-auto tw-min-w-60 tw-px-2 tw-py-0 tw-shadow-sm tw-text-indigo-700 sm:tw-text-sm focus:tw-outline-none tw-rounded disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ";
    if (error && touched) {
      result += "tw-placeholder-red-300 focus:tw-ring-red-500 focus:tw-border-red-500 tw-border-red-300 tw-border-2 tw-text-red-900 ";
    } else {
      result += "focus:tw-ring-2 focus:tw-ring-indigo-700 focus:tw-border-indigo-700 tw-border tw-border-gray-500 ";
    }
    if (isLoading) {
      result += " tw-opacity-50 disabled:tw-cursor-not-allowed ";
    }

    return result;
  }

  const handleChange = (e) => {
    setFocused(true);
    onChange(e);
    updateCaret();
  }

  const updateCaret = () => {
    if (useInputText) {
      if (inputRef.current) {
        const { selectionStart, selectionEnd } = inputRef.current;

        setStart(selectionStart);
        setEnd(selectionEnd);
      }
    } else {
      if (textareaRef.current) {
        const { selectionStart, selectionEnd } = textareaRef.current;

        setStart(selectionStart);
        setEnd(selectionEnd);
      }
    }
  }

  const handleBlur = (e) => {
    setFocused(false);
  }

  return (
    <>
      <span ref={spanRef} className="tw-absolute tw-opacity-0 tw-whitespace-pre" style={spanStyle}>{value}</span>
      {useInputText
        ?
        (
          <input
            id={id}
            ref={inputRef}
            type={"text"}
            title={title}
            aria-label={title || 'enter text'}
            name={name}
            value={value || ''}
            disabled={disabled}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
            onChange={handleChange}
            onBlur={handleBlur}
            onContextMenu={onContextMenu}
            className={classNames()}
            style={internalStyle}
            {...minmaxProps}
          />
        )
        :
        (
          <TextareaAutosize
            id={id}
            ref={textareaRef}
            title={title}
            aria-label={title || 'enter text'}
            name={name}
            value={value || ''}
            disabled={disabled}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
            onChange={handleChange}
            onBlur={handleBlur}
            onContextMenu={onContextMenu}
            className={classNames()}
            style={internalTextAreaStyle}
            {...minmaxProps}
          />
        )
      }
      {
        error && touched &&
        <span className="tw-px-1 tw-text-sm tw-text-red-800 tw-font-bold tw-break-words">
          {error}
        </span>
      }
    </>
  )
}